import React from "react"
import {withRouter} from 'react-router-dom'
import {Button, Card, Col, Icon, message, Row, Spin, Upload, Popover} from "antd"
import {Storage} from "aws-amplify"
import BaseDocumentControl from "./BaseDocumentControl"
import {connect} from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"
import uuid from 'react-uuid';

function beforeUpload(file) {
    const isValidFile = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
    if (!isValidFile) {
        message.error('Solo puedes subir documentos en formato JPG/PNG/PDF');
    }
    return isValidFile;
}

class UploadDocument extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            documento: '',
            documentOriginalName: '',
            documentName: '',
            loadingDocument: false
        }
    }

    componentDidMount = async () => {
    }

    onChange = async (documento, idx) => {
        if (!documento) return
        const ext = documento.name.split('.').pop();
        this.setState({documento, documentName: uuid() + '.' + ext, documentOriginalName: documento.name});

        message.info(documento.name + ' ha sido adjuntado')
    }

    uploadDocument = async () => {
        this.setState({loadingDocument:true})
        Storage.put('cddocument/' + this.state.documentName, this.state.documento).then(response => {
            message.success("El documento " + this.state.documentOriginalName + " se está procesando. En unos minutos podrá ver el documento desde la vista", 4)
            this.setState({ documento: '', documentName: '', documentOriginalName: '', loadingDocument: false})
        }).catch(err => {
            message.error("Error al subir documento")
            console.log(err)
            this.setState({ documento: '', documentName: '', documentOriginalName: '', loadingDocument: false})
        })
    }

    render() {
        if (this.state.loading_alta ){
            return (
                <BaseDocumentControl selected='document-control'>
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseDocumentControl>
            )
        } else {
            return (
                <BaseDocumentControl
                    selected="upload-document">
                        <Card title={'Subir Documento'}>
                            <Row type="flex" justify="space-around" align="middle">
                                <Col style={{minHeight: '360px'}}>
                                    <Upload
                                        name='documento'
                                        method='get'
                                        accept='.png,.jpg,.pdf'
                                        action ={(evt)=>this.onChange(evt,'documento')}
                                        beforeUpload={beforeUpload}
                                    >
                                        <Popover placement ='bottom' content={<div><p><b>Formato:</b> .jpg o .png o .pdf</p></div>}>
                                            <Button disabled={this.state.documento} loading={this.state.loadingDocument} style ={{width:320}}>
                                                <Icon type='upload'></Icon> Documento
                                            </Button>
                                        </Popover>
                                    </Upload>
                                    <Button disabled={!this.state.documento} style={{marginLeft: '80px', marginTop: '20px'}} key="submit" type="primary" onClick={this.uploadDocument}>
                                        Subir documento
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                </BaseDocumentControl>
            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UploadDocument));